import BaseTabs from '../../Components/BaseTabs';
import { SUBSIDIARYTABS } from '../../General';

export default class Tabs extends BaseTabs {
    getTabs(): any[] {
        const t = this.translate();
        return [
            {
                faIcon: 'fas fa-users',
                title: t('members'),
                tab: SUBSIDIARYTABS.MEMBERS
            },
            {
                faIcon: 'fas fa-wrench',
                title: t('settings'),
                tab: SUBSIDIARYTABS.SETTINGS
            }
        ];
    }

    getName(): string {
        return 'Subsidiary';
    }
}